import { getMainInternshipsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainInternshipsSearchRoutePath';
import { getMainJobsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainJobsSearchRoutePath';
import { getMainOrgSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainOrgSearchRoutePath';

import { FindAJobDropdownData } from './FindAJobDropdownData';

export const findAJobDropdownDataEn: FindAJobDropdownData = {
  triggerText: 'Find a Job',
  triggerHref: getMainJobsSearchRoutePath({ lang: 'en' }),
  search: {
    title: 'Search',
    items: [
      {
        type: 'job',
        icon: 'briefcase',
        title: 'Jobs',
        href: getMainJobsSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'internship',
        icon: 'sign-path',
        title: 'Internships',
        href: getMainInternshipsSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'org',
        icon: 'building',
        title: 'Organizations',
        href: getMainOrgSearchRoutePath({ lang: 'en' }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        image: 'illustrations/salary-illustration.svg',
        title: 'Nonprofit Salary Explorer',
        description:
          'Crowdsourced compensation data in the nonprofit sector. Insights for job seekers and employers.',
        href: '/nonprofit-salary-explorer',
      },
      {
        image: 'illustrations/article-illustration.svg',
        title: 'Career Advice',
        description:
          'Informative and practical resources to help guide you throughout your social-impact career.',
        href: '/en/careers',
      },
    ],
  },
};
